export enum AppRoutes {
	CLUBS_CREATE = 'CLUBS_CREATE',
	RULES_DETAIL = 'RULES_DETAIL',
	CLUB_DETAIL = 'CLUB_DETAIL',
	ROOM_CREATE = 'ROOM_CREATE',
	NOT_FOUND = 'NOT_FOUND',
	PROFILE = 'PROFILE',
	RULES = 'RULES',
	CLUBS = 'CLUBS',
	HOME = 'HOME',
	ROOM = 'ROOM',
	GAME = 'GAME',

	ALL_MATCH = 'ALL_MATCH',
}
